<template>
  <div>
    <v-text-field
      v-model="search"
      class="search-input"
      label="Поиск"
      color="accent"
      single-line
      hide-details
      @keypress.enter="searchRound"
    >
      <template #append-outer>
        <v-icon class="icon" style="font-size: 18px" @click="searchRound">fas fa-check</v-icon>
        <v-icon class="icon" @click="cancelSearch">fas fa-times</v-icon>
      </template>
    </v-text-field>
    <paginated-table
      :items="searchRounds.length === 0 ? items : searchRounds"
      :headers="headers"
      :loading="loading"
      :pullFunction="getRounds"
    >
      <template #items="props">
        <DiceStatisticsItem :item="props.item" />
      </template>
    </paginated-table>
  </div>
</template>

<script>
import PaginatedTable from '../../../PaginatedTable'
import DiceStatisticsItem from './DiceStatisticsItem'
import { getGeneralStatistics, getStatisticsRounds } from '../../../../../api/dice'

export default {
  name: 'DiceStatisticsTable',
  components: { DiceStatisticsItem, PaginatedTable },
  data () {
    return {
      items: [],
      searchRounds: [],
      search: '',
      loading: false,
      pagination: {
        sortBy: 'timestart',
        descending: true
      },
      headers: [
        { text: 'id игры', value: 'game_id' },
        { text: 'Ставка', value: 'bet' },
        { text: 'id польз.', value: 'user_id' },
        { text: 'Напр.', value: 'orientation' },
        { text: 'Выбранное знач.', value: 'chosen_number' },
        { text: 'Шанс', value: 'rate' },
        { text: 'Коэф.', value: 'factor' },
        { text: 'Выигрыш', value: 'prize' },
        { text: 'Выпавшее знач.', value: 'result' },
        { text: 'Дата', value: 'created_at' }
      ]
    }
  },
  watch: {
    pagination () {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  mounted () {
    this.getRounds(1)
  },
  methods: {
    searchRound () {
      this.loading = true
      getStatisticsRounds({
        limit: 25, offset: 0, game_id: this.search
      }).then(response => {
        this.searchRounds = response.data.items
        if (this.searchRounds.length === 0)
          this.$store.dispatch('showErrorMessage', 'Раунд не найден')

        this.loading = false
      })
        .catch(error => {
          this.loading = false
          console.log(error)
          this.$store.dispatch('showErrorMessage', 'Ошибка')
        })
    },
    cancelSearch () {
      this.search = ''
      this.searchRounds = []
    },
    getRounds (page) {
      getStatisticsRounds({ limit: 26, offset: (page - 1) * 25 }).then(response => {
        this.items = response.data.items
      })
    }
  }
}
</script>

<style scoped>
    .icon {
        cursor: pointer;
        font-size: 20px;
        padding: 2px 4px;
    }

    .icon:hover {
        background: #eeeef4;
        border-radius: 4px;
    }

    .search-input {
        flex: none;
        width: 30%;
        margin-left: auto;
        margin-bottom: 10px;
    }
</style>
